<template>
  <div>
    <s-toolbar-crud
      v-if="!noToolbar"
      :configuration="configuration"
      :title="title"
      :searchInput="searchInput"
      :search="!noSearch"
      :loading="loading"
      @searchEvent="searchEvent($event)"
      @refresh="refresh(null)"
      @addEvent="AddEventClick()"
    >
      <template v-slot:options>
        <slot name="options"></slot>
      </template>
    </s-toolbar-crud>

    <v-toolbar flat dense color="grey lighten-4" class="mb-2 rounded">
      <v-btn icon small @click="goBack()" :disabled="breadcrumbs.length <= 1">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-breadcrumbs :items="breadcrumbs" class="py-0">
        <template v-slot:item="{ item }">
          <v-breadcrumbs-item
            @click="navigateToFolder(item)"
            class="cursor-pointer font-weight-bold"
          >
            {{ item.text.toUpperCase() }}
          </v-breadcrumbs-item>
        </template>
      </v-breadcrumbs>
    </v-toolbar>

    <div v-if="!showForm">
      <slot name="filter"></slot>
    </div>


    <v-card
      elevation="0"
      class="pa-4"
      min-height="400"
      outlined
      style="border-color: #e0e0e0"
    >
      <v-row
        v-if="loading"
        justify="center"
        align="center"
        style="height: 300px"
      >
        <v-progress-circular
          indeterminate
          color="primary"
          size="48"
        ></v-progress-circular>
      </v-row>

      <v-row v-else-if="desserts.length > 0">
        <v-col
          v-for="item in desserts"
          :key="item[config.propID || 'ID']"
          cols="6"
          sm="4"
          md="3"
          lg="2"
          class="text-center"
        >
          <v-card
            outlined
            hover
            class="pa-3 d-flex flex-column align-center justify-center position-relative"
            @click="selectItem(item)"
            @dblclick="handleDoubleClick(item)"
            :color="
              selected.some(
                (x) => x[config.propID || 'ID'] === item[config.propID || 'ID'],
              )
                ? 'blue lighten-5'
                : ''
            "
            style="
              border-radius: 8px;
              transition: 0.2s;
              min-height: 145px; /* Camas de altura mínima flexible */
              height: 100%; /* Para que todas las tarjetas de la misma fila midan lo mismo */
              cursor: pointer;
            "
          >
            <v-simple-checkbox
              v-if="config.selection"
              :value="
                selected.some(
                  (x) =>
                    x[config.propID || 'ID'] === item[config.propID || 'ID'],
                )
              "
              class="position-absolute"
              style="top: 8px; right: 8px"
              disabled
            ></v-simple-checkbox>

            <v-icon size="56" :color="isFolderCheck(item) ? 'amber' : 'blue'">
              {{
                isFolderCheck(item) ? "mdi-folder" : "mdi-file-document-outline"
              }}
            </v-icon>

            <div
              class="mt-2 text-caption font-weight-medium text-break"
              style="
                max-width: 100%;
                color: #374151;
                white-space: pre-line;
                word-break: break-word;
              "
            >
              {{ getItemLabel(item) }}
            </div>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else justify="center" align="center" style="height: 300px">
        <div class="text-center grey--text text--darken-1">
          <v-icon size="64" color="grey lighten-1"
            >mdi-folder-open-outline</v-icon
          >
          <p class="mt-2 text-body-1">
            No se encontraron registros en este nivel
          </p>
        </div>
      </v-row>
    </v-card>

    <v-row
      class="mt-3 pa-2"
      align="center"
      justify="space-between"
      v-if="total > 0"
    >
      <v-col cols="12" sm="4" class="text-caption grey--text text--darken-1">
        Mostrando {{ desserts.length }} de {{ total }} registros
      </v-col>
      <v-col cols="12" sm="8" class="d-flex justify-end">
        <v-pagination
          v-model="page"
          :length="Math.ceil(total / parametersPagination.length)"
          :total-visible="5"
          circle
          dense
        ></v-pagination>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import draggable from "vuedraggable";
import SCrud from "../../services/General/SCrudService";
import _sDefinition from "@/services/General/DefinitionService.js";
import GenericService from "../../services/General/GenericService";

export default {
  components: { draggable },
  name: "SCrud",
  props: {
    configuration: {
      type: Boolean,
      default: false,
    },
    nameScrud: { type: String, default: "" },
    showCount: { type: Boolean, default: false },
    selectItemsPerPage: { type: Number, default: 25 },
    mobile: { type: Number, default: 600 },
    approve: { type: Boolean, default: false },
    noFull: { type: Boolean, default: false },
    noEdit: { type: Boolean, default: false },
    save: { type: Boolean, default: false },
    view: { type: Boolean, default: false },
    //expandir detalles
    expandDetail: { type: Boolean, default: false },
    //RESTAURAR EL ITEM HACE STAAATUS IGUAL A 1
    restore: { type: Boolean, default: false },
    deleteNoFunction: { type: Boolean, default: false },
    searchInput: { type: Boolean, default: false },
    //desabilita por accion del boton agregar de abrir el formulario: emite evento add(item)
    addNoFunction: { type: Boolean, default: false },
    config: { type: Object, default: null },
    noToolbar: { type: Boolean, default: false },
    colorToolbar: { type: String, default: "#999999" },
    height: { type: String, default: "320" },
    noSearch: { type: Boolean, default: false },
    noDark: { type: Boolean, default: false },
    noFooter: { type: Boolean, default: false },
    load: { type: Boolean, default: false },
    transfer: { type: Boolean, default: false },
    enable: { type: Boolean, default: false },
    close: { type: Boolean, default: false },
    off: {
      type: Boolean,
      default: false,
    },
    filter: { type: Object, default: null },
    title: { type: String, default: "" },
    refreshTable: { type: Boolean, default: false },
    add: { type: Boolean, default: false },
    sync: { type: Boolean, default: false },
    btnsearch: { type: Boolean, default: false },
    edit: { type: Boolean, default: false },
    remove: { type: Boolean, default: false },
    excel: { type: Boolean, default: false },
    pdf: { type: Boolean, default: false },
    print: { type: Boolean, default: false },
    parentID: { type: Number, default: 0 },
    //SI ES SELECCION UNICA
    singleRow: { type: Boolean, default: true },
    //GUARDA O EDITA MULTIPLES FILAS SELECCIONADAS..ACTUALMENTE SOLO ESTA HABILITADO PARA ELIMINAR REGISTROS MASIVOS
    saveList: { type: Boolean, default: false },
    sortable: { type: Boolean, default: false },
    noBorder: { type: Boolean, default: false },
    //FORMULARIO DE AGREGAR O EDITAR NO SE OCULTA
    formPermanent: { type: Boolean, default: false },
    //DESABILITA LA ACCION DE QUE EL DOBLECLICK EJECUTE LA ACCION DEL BOTON DE EDITAR
    noDoubleClick: { type: Boolean, default: false },
    //DESABILITA EL MENSAJE DE CONFIRMACIÓN AL AGREGAR O EDITAR O ELIMINAR
    noConfimationSave: { type: Boolean, default: false },
    groupBy: null,
    showGroupBy: { type: Boolean, default: false },
    rowDefault: { type: Boolean, default: true }, //enviar false para que no se seleccione fila por defecto
    itemsPerPage: { type: Array, default: () => [25, 50, 100, 200, -1] },
    filtersActive: { type: Boolean, default: false },
    exportExcel: { type: Boolean, default: false },
    isColor: { type: Boolean, default: false },
    viewEventFormPermanent: { type: Boolean, default: false },
    //Si es true, el click en la fila NO marca el checkbox, solo emite el evento rowSelected
    clickRowNoSelect: { type: Boolean, default: false },
    folderNavigation: { type: Boolean, default: true },
    folderFilterKey: { type: String, default: "ParentID" },
    folderNameField: { type: String, default: "" },
    folderLabelFields: {
      type: Array,
      default: () => [
        "Name",
        "Description",
        "RprDescription",
        "RequestedPosition",
        "CmpName",
      ],
    },
  },
  data: () => ({
    page: 1,
    filters: {},
    //itemsPerPage:[25, 50, 100, 200, -1],
    expanded: [],
    //peticion actual de paginacion del crud
    request: null,
    doubleClick: false,
    showForm: false,
    messageError: [],
    row: null,
    total: 0,
    loading: true,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    search: "",
    selected: [],
    desserts: [],
    filteredDesserts: [],
    parametersPagination: {
      filter: {},
      draw: 1,
      start: 0,
      length: 10,
      order: [{ dir: "asc", column: "" }],
      searchText: "",
    },
    btnsearchKey: false,
    dialogScrud: false,
    configHeader: [],
    configHeaderBackup: [],
    configurationEdit: false,
    SrdIsAdmin: 0,
    configModel: {},
    configModelBackup: {},
    activeTooltip: null,
    tooltipX: 0,
    tooltipY: 0,
    selectDefinition: null,
    itemSelectDefinition: [],
    dataExcel: [],
    breadcrumbs: [
      { text: "Raíz", id: 0 }, // Carpeta raíz inicial
    ],
    currentFolderID: 0,
  }),
  watch: {
    page(newVal) {
      this.parametersPagination.start =
        (newVal - 1) * this.parametersPagination.length;
      this.getAnswer();
    },
    searchText(newVal) {
      this.parametersPagination.searchText = newVal;
      this.page = 1; // Resetea página
      this.parametersPagination.start = 0;
      this.getAnswer();
    },
    filter: {
      handler(newVal) {
        this.page = 1;
        this.parametersPagination.start = 0;
        this.getAnswer();
      },
      deep: true,
    },
    "options.page"() {
      this.getDataFromApi().then((data) => {
        this.desserts = data.items;
        this.total = data.total;
      });
    },
    desserts(newVal) {
      // Reiniciar al recibir nuevos datos
      this.filteredDesserts = [...newVal];
    },
    "config.headers": {
      handler() {
        if (this.config?.headers) {
          this.configHeader = this.config.headers.map((item) => ({
            ...item,
            draggable: item.draggable !== false,
          }));
        } else {
          this.configHeader = [];
        }

        this.configModel = this.config?.model ? { ...this.config.model } : {};
      },
      deep: true,
      immediate: true,
    },
    refreshTable() {
      this.selected = [];
      this.getDataFromApi().then((data) => {
        (this.desserts = data.items), (this.total = data.total);
        if (this.desserts.length > 0) {
          this.refresh(this.desserts[0]);
        }
      });
    },
    search() {
      this.debouncedGetAnswer();
    },
    options: {
      handler() {
        this.getDataFromApi().then((data) => {
          this.desserts = data.items;
          this.total = data.total;

          if (this.desserts.length > 0) this.refresh(this.desserts[0]);
        });
      },
    },
    configHeader: {
      deep: true,
      handler(newHeaders) {
        newHeaders.forEach((element) => {
          if (
            !this.configModel.hasOwnProperty(element.value) &&
            element.value !== "ID"
          ) {
            this.$set(this.configModel, element.value, "");
          }
        });

        if (this.configModel.hasOwnProperty("ID")) {
          this.$set(this.configModel, "ID", this.configModel["ID"]);
        }
      },
    },
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve) => {
        // Sincronizamos la paginación
        this.parametersPagination.start =
          (this.options.page - 1) * this.parametersPagination.length;

        // CRUCIAL: Le inyectas al filtro el ID de la carpeta en la que estás parado actualmente
        const baseFilter = { ...(this.filter || {}) };
        if (this.folderNavigation && this.folderFilterKey) {
          baseFilter[this.folderFilterKey] = this.currentFolderID;
        }
        this.parametersPagination.filter = baseFilter;

        this.config.service
          .pagination(this.parametersPagination, this.$fun.getUserID())
          .then((response) => {
            let items = response.data.data;
            const total = response.data.recordsTotal;

            resolve({ items, total });
            this.loading = false;
          });
      });
    },

    // Manejo del doble click
    handleDoubleClick(item) {
      if (this.isFolderCheck(item)) {
        this.$emit("openFolder", item);
        if (!this.folderNavigation) {
          return;
        }

        const idProp = this.config.propID || "ID";
        this.currentFolderID = item[idProp];

        // Agregamos al Breadcrumb
        const folderName = this.getItemLabel(item);
        this.breadcrumbs.push({ text: folderName, id: this.currentFolderID });

        // Resetear paginado e ir al API
        this.page = 1;
        this.parametersPagination.start = 0;
        this.getAnswer();
      } else {
        // Si es un archivo final, emitimos un evento al componente padre
        this.$emit("openFile", item);
      }
    },

    // Navegar usando las migas de pan (Breadcrumbs)
    navigateToFolder(folder) {
      const index = this.breadcrumbs.findIndex((x) => x.id === folder.id);
      if (index !== -1) {
        this.breadcrumbs = this.breadcrumbs.slice(0, index + 1);
        this.currentFolderID = folder.id;
        this.page = 1;
        this.parametersPagination.start = 0;
        this.getAnswer();
      }
    },

    goBack() {
      if (this.breadcrumbs.length > 1) {
        this.breadcrumbs.pop();
        this.currentFolderID = this.breadcrumbs[this.breadcrumbs.length - 1].id;
        this.page = 1;
        this.parametersPagination.start = 0;
        this.getAnswer();
      }
    },

    selectItem(item) {
      const idProp = this.config.propID || "ID";
      if (this.config.selection) {
        // Comportamiento de selección múltiple (Toggle)
        const index = this.selected.findIndex(
          (x) => x[idProp] === item[idProp],
        );
        if (index > -1) {
          this.selected.splice(index, 1);
        } else {
          this.selected.push(item);
        }
      } else {
        // Selección única
        this.selected = [item];
      }
      this.row = item;
      this.$emit("rowSelected", this.selected);
    },

    refresh(obj) {
      this.getDataFromApi().then((data) => {
        this.desserts = data.items;
        this.total = data.total;
      });
    },

    searchEvent(search) {
      this.searchText = search;
    },
    hasFilter(columnValue) {
      return this.config.filters.some((f) => f.value === columnValue);
    },
    applyFilters() {
      //console.log("this.filters", this.filters);
      const activeFilters = this.filters;

      this.filteredDesserts = this.desserts.filter((item) =>
        Object.keys(activeFilters).every((key) => {
          const filterValue = activeFilters[key];
          if (!filterValue) return true;
          const itemValue = item[key] != null ? String(item[key]) : "";

          return itemValue
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        }),
      );
    },
    searchBtn() {
      // console.log("searchBtn", this.filter);
      this.btnsearchKey = false;
      this.options.page = 1;
      this.selected = [];
      if (!this.noToolbar) this.$refs.toolbar.showForm(false, false);
      this.getDataFromApi().then((data) => {
        this.desserts = data.items;
        this.total = data.total;
        if (this.desserts.length > 0) this.refresh(this.desserts[0]);
      });
      this.$emit("btnsearch");
    },
    EditEvent() {
      this.$emit("EditEvent", this.selected);
    },
    AddEventClick() {
      this.$emit("addEvent");
    },

    activePrd() {
      this.$emit("activePrd");
    },
    formatItem(value, prop) {
      let val = value;
      if (prop == "date") val = this.$fun.formatDateView(val);
      if (prop == "time") val = this.$fun.formatTimeView(val);
      if (prop == "datetime") val = this.$fun.formatDateTimeView(val);
      return val;
    },
    selectedCheckSlot(obj) {
      let any = obj.item;
      if (
        this.selected.find((x) => {
          return x == any;
        }) != null
      )
        this.selected = this.selected.filter((x) => {
          return x != any;
        });
      else {
        this.selected.push(any);
        console.log("objetos", obj);
        this.row = Object.assign({}, any);
      }
      this.$emit("itemSelected", any);
      this.$emit("rowSelected", this.selected);
    },
    loadEvent() {
      this.$emit("load");
    },

    transferEvent() {
      this.$emit("transfer");
    },
    enableEvent() {
      this.$emit("enable");
    },
    isFolderCheck(item) {
      if (item && Object.prototype.hasOwnProperty.call(item, "IsFolder")) {
        return !!item.IsFolder;
      }
      return true;
    },
    getItemLabel(item) {
      if (!item || typeof item !== "object") return "Sin nombre";

      if (this.folderNameField && item[this.folderNameField]) {
        return String(item[this.folderNameField]);
      }

      const fields = Array.isArray(this.folderLabelFields)
        ? this.folderLabelFields
        : [];

      const parts = fields
        .map((key) => item[key])
        .filter(
          (value) =>
            value !== null &&
            value !== undefined &&
            String(value).trim() !== "",
        )
        .map((value) => String(value).trim());

      if (parts.length > 0) {
        return parts.join(" \n");
      }

      return "Sin nombre";
    },
    deleteExecuted() {
      this.$emit("removed");
    },
    deleteEvent(item) {
      if (this.singleRow) this.$emit("delete", item);
      else this.$emit("delete", this.selected);
    },
    pdfEvent() {
      if (this.row[this.propID] != 0) this.$emit("pdf", this.row);
      else this.$emit("pdf", null);
    },
    getProps() {
      let r = [];
      for (var prop in this.configModel) r.push(prop);
      return r;
    },
    getNameSlot(p) {
      return "item." + p;
    },
    btnAdd() {
      this.$refs.toolbar.showForm(true, false);
      this.$emit("clearForm");
    },
    btnSave() {
      this.$refs.toolbar.saveEvent();
    },

    removed(obj) {
      if (this.saveList) obj = obj[0];
      this.refresh(obj);
      this.$emit("removed");
    },
    doubleClickFunc: function (mouse, row) {
      if (this.edit) this.doubleClick = !this.doubleClick;
      this.$emit("doubleClick", row.item);
      this.$emit("dblClick", row.item);
    },
    refresh(obj) {
      this.expanded = [];
      if (obj == null) {
        this.getDataFromApi().then((data) => {
          this.desserts = data.items;
          this.total = data.total;
          if (this.rowDefault && this.desserts.length > 0) {
            this.selected = this.formPermanent ? [] : [this.desserts[0]];
            this.row = Object.assign({}, this.desserts[0]);
            this.$emit("rowSelected", this.selected);
          } else {
            this.selected = [];
            this.row = {};
            this.$emit("rowSelected", []);
          }
        });
      } else if (this.propID != null) {
        let ob = this.desserts.find((x) => obj[this.propID] == x[this.propID]);
        /* console.log("ob",ob); */
        for (var prop in ob) {
          ob[prop] = obj[prop];
        }

        if (this.rowDefault) {
          this.selected = this.formPermanent ? [] : [ob];
        }

        this.row = Object.assign({}, ob);
        this.$emit("rowSelected", this.selected);
      }
      if (this.formPermanent) {
        this.restart();
      }
    },
    searchEvent(search) {
      this.parametersPagination.searchText = search;
      if (this.btnsearch) {
        this.btnsearchKey = true;
        return;
      }

      this.options.page = 1;
      this.getDataFromApi().then((data) => {
        this.desserts = data.items;
        this.total = data.total;
        if (this.desserts.length > 0) this.refresh(this.desserts[0]);
      });
    },

    saveExecute() {
      return new Promise((resolve, reject) => {
        let objsave = this.row;
        objsave.UsrCreateID =
          objsave[this.propID] == null || objsave[this.propID] == 0
            ? this.$fun.getUserID()
            : objsave.UsrCreateID;
        objsave.UsrUpdateID =
          objsave[this.propID] != null && objsave[this.propID] > 0
            ? this.$fun.getUserID()
            : 0; //objsave.UsrCreateID;
        this.config.service.save(objsave, this.$fun.getUserID()).then(
          (response) => {
            resolve(response);
            if (response.status == 200) {
              this.$emit("returnObject", response.data);
              let obj = Object.assign({}, this.row);
              if (obj[this.propID] == 0) {
                this.getDataFromApi().then((data) => {
                  this.desserts = data.items;
                  this.total = data.total;
                  if (this.desserts.length > 0) this.refresh(this.desserts[0]);
                  this.showForm = false || this.formPermanent;
                  this.$fun.alert("Agregado Correctamente", "success");
                });
              } else {
                this.refresh();
                this.showForm = false || this.formPermanent;
                this.$fun.alert("Actualizado Correctamente", "success");
              }
            }
          },
          (e) => {
            reject(e);
          },
        );
      });
    },
    saveEvent() {
      if (this.save) {
        this.$emit("save", this.row);
        return;
      }

      let obj = Object.assign({}, this.row);
      for (var prop in this.configModel)
        if (this.configModel[prop] == "time")
          obj[prop] = this.$moment(new Date()).format("L") + this.row[prop];

      this.row.save = () => {
        return new Promise((resolve, reject) => {
          if (this.noConfimationSave)
            this.saveExecute().then(
              (r) => {
                resolve(r);
              },
              (e) => {
                reject(e);
              },
            );
          else
            this.$fun.alert("Seguro de Guardar?", "question").then((val) => {
              if (val.value)
                this.saveExecute().then(
                  (r) => {
                    resolve(r);
                  },
                  (e) => {
                    reject(e);
                  },
                );
            });
        });
      };
      this.$emit("save", this.row);
    },
    reportExcel() {
      if (this.row)
        this.parametersPagination.filter[this.propID] = this.row.OrdID;
      this.config.service
        .excel(this.parametersPagination, this.$fun.getUserID(), this.row)
        .then((r) => {
          this.$fun.downloadFile(
            r.data,
            this.$const.TypeFile.EXCEL,
            this.title,
          );
        });
    },
    rowClick: function (item, row) {
      // Si clickRowNoSelect está activo, solo actualiza row y emite un evento específico sin modificar selected
      if (this.clickRowNoSelect) {
        this.expanded = [item];
        this.row = Object.assign({}, item);
        this.$emit("rowClicked", item);
        return;
      }

      if (this.singleRow) {
        this.expanded = [item];
        this.selected = [item];
        this.row = Object.assign({}, item);
      } else {
        if (
          this.selected.find((x) => {
            return x == item;
          }) != null
        )
          this.selected = this.selected.filter((x) => {
            return x != item;
          });
        else {
          this.selected.push(item);
          this.row = Object.assign({}, item);
        }
      }
      this.$emit("rowSelected", this.selected);
      if (this.noEdit) this.btnAdd();
    },
    restartEntity(entity) {
      if (!this.formPermanent) {
        this.row = entity;
        this.selected = [entity];
        this.$emit("rowSelected", this.selected);
      }
    },
    cancelRequest() {
      this.request.cancel();
      this.request = null;
    },
    areObjectsEqual(objA, objB) {
      const keysA = Object.keys(objA);
      const keysB = Object.keys(objB);

      if (keysA.length !== keysB.length) return false;

      for (let key of keysA) {
        if (objA[key] !== objB[key]) return false;
      }

      return true;
    },
    getDataFromApi() {
      // console.log("CRUD parametersPagination compa", this.parametersPagination.filter == this.filter);
      // if ( this.areObjectsEqual( this.parametersPagination.filter, this.filter) ) {
      //   return new Promise((resolve, reject) => {
      //     reject({})
      //   });
      // }
      // console.log("CRUD filter", this.filter);
      // console.log("CRUD parametersPagination", this.parametersPagination.filter);

      //samir
      // this.filterTemp = this.filter;
      // console.log("this.filterTemp", this.filterTemp);

      if (this.request) this.cancelRequest();
      const axiosSource = axios.CancelToken.source();
      //  console.log("----------------------------------------------------");
      //  console.log(axiosSource.token);
      this.request = { cancel: axiosSource.cancel, msg: "Loading..." };

      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, sortDesc, page, itemsPerPage } = this.options;
        this.parametersPagination.start =
          (this.options.page - 1) * this.parametersPagination.length;
        const baseFilter = { ...(this.filter || {}) };
        if (this.folderNavigation && this.folderFilterKey) {
          baseFilter[this.folderFilterKey] = this.currentFolderID;
        }
        this.parametersPagination.filter = baseFilter;
        this.parametersPagination.length = itemsPerPage;
        if (this.options.sortBy.length > 0)
          this.parametersPagination.order = [
            {
              column: this.options.sortBy[0],
              dir: this.options.sortDesc[0] ? "desc" : "asc",
            },
          ];
        this.config.service
          .pagination(
            this.parametersPagination,
            this.$fun.getUserID(),
            axiosSource,
          )
          .then((response) => {
            this.selected = [];
            this.$emit("rowSelected", this.selected);

            this.restart();
            let items = response.data.data;
            items.forEach((element) => {
              try {
                for (var prop in this.configModel)
                  if (this.configModel[prop] == "date")
                    element[prop] =
                      element[prop] == null
                        ? ""
                        : this.$moment(element[prop]).format(
                            this.$const.FormatDateDB,
                          );
                  else if (this.configModel[prop] == "time")
                    element[prop] =
                      element[prop] == null
                        ? ""
                        : this.$moment(element[prop]).format(
                            this.$const.FormatTimeDB,
                          );
                  else if (this.configModel[prop] == "time2")
                    element[prop] =
                      element[prop] == null
                        ? ""
                        : this.$moment(element[prop]).format(
                            this.$const.FormatTimeShortView,
                          );
                  else if (this.configModel[prop] == "decimal")
                    element[prop] =
                      element[prop] == null ? "" : element[prop].toFixed(2);
                  else if (this.configModel[prop] == "decimal4")
                    element[prop] =
                      element[prop] == null ? "" : element[prop].toFixed(4);
                  else if (this.configModel[prop] == "datetime")
                    element[prop] =
                      element[prop] == null
                        ? ""
                        : this.$moment(element[prop]).format(
                            this.$const.FormatDateTimeDB,
                          );
                  else if (this.configModel[prop] == "currency")
                    element[prop] =
                      element[prop] == null
                        ? ""
                        : new Intl.NumberFormat("es-PE", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                            // style: "unit",
                            // unit: "KGM",
                          }).format(element[prop]);
              } catch (error) {
                let col =
                  (
                    this.itemSelectDefinition.find(
                      (item) => item.DedAbbreviation == this.configModel[prop],
                    ) || {}
                  ).DedDescription || "";
                let col2 = this.configHeader.find((x) => x.value == prop);
                this.$fun.alert(
                  `Error en ${col2.text} por el formato ${col}`,
                  "warning",
                );
              }
              // Nueva lógica de selección condicional
              if (
                this.config.itemSelectable &&
                typeof this.config.itemSelectable === "function"
              ) {
                element.isSelectable = this.config.itemSelectable(element);
              } else {
                element.isSelectable = true;
              }
            });
            const total = response.data.recordsTotal;
            this.$emit("getDataRefresh", items);

            this.$emit("getFullData", response.data);
            this.dataExcel = items;
            if (!this.formPermanent) this.showForm = false;
            setTimeout(() => {
              this.loading = false;
              resolve({ items, total });
            }, 0);
          });
      });
    },
    toggleSelectAll({ items, value }) {
      if (value) this.selected = items;
      else this.selected = [];
      this.$emit("rowSelected", this.selected);
    },
    getAnswer() {
      this.loading = true;

      const baseFilter = { ...(this.filter || {}) };
      if (this.folderNavigation && this.folderFilterKey) {
        baseFilter[this.folderFilterKey] = this.currentFolderID;
      }
      this.parametersPagination.filter = baseFilter;

      this.config.service
        .pagination(this.parametersPagination, this.$fun.getUserID())
        .then((response) => {
          this.desserts = response.data.data;
          this.total = response.data.recordsTotal;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    restartCreated() {
      this.selected = [];

      let r = {};
      for (var prop in this.configModel) {
        if (this.configModel[prop] == "date") {
          r[prop] = null;
        } else if (this.configModel[prop] == "string") r[prop] = "";
        else if (this.configModel[prop] == "number") r[prop] = 0;
        else if (this.configModel[prop] == "ID") r[prop] = 0;
        else if (this.configModel[prop] == "time") r[prop] = "00:00";
        else if (this.configModel[prop] == "boolean") r[prop] = 0;
        else r[prop] = "";
        r.SecStatus = null;
      }

      this.row = Object.assign(r, {});
    },
    restart() {
      this.row = null;
      this.selected = [];

      let r = {};
      for (var prop in this.configModel) {
        if (this.configModel[prop] == "date") {
          r[prop] = null;
        } else if (this.configModel[prop] == "string") r[prop] = "";
        else if (this.configModel[prop] == "number") r[prop] = 0;
        else if (this.configModel[prop] == "ID") r[prop] = 0;
        else if (this.configModel[prop] == "time") r[prop] = "00:00";
        else if (this.configModel[prop] == "boolean") r[prop] = 0;
        else r[prop] = "";
        r.SecStatus = null;
      }

      this.row = Object.assign(r, {});
    },
    addEvent() {
      //alert("nuevo")
      if (this.row[this.propID] != 0) this.$emit("add", this.row);
      else this.$emit("add", null);
    },
    editEvent() {
      //alert("sdfsdfds");
      if (this.row[this.propID] != 0) this.$emit("edit", this.row);
      else this.$emit("edit", null);
    },
    showFormDefEvent(options) {
      if (options.add) {
        this.restart();
        this.$emit("rowSelected", this.selected);
      }
      this.showForm = options.add || options.edit || this.formPermanent;
    },
    checkMove(event) {
      if (
        event.draggedContext.element.draggable === false &&
        event.to !== event.from
      ) {
        return false;
      }
      return true;
    },
    configurationEvent() {
      this.dialogScrud = true;
      this.configHeaderBackup = [...this.configHeader];
      this.configModelBackup = { ...this.configModel };
      this.configurationEdit = false;
    },
    closeConfigurationEvent() {
      this.dialogScrud = false;
      this.configHeader = this.configHeaderBackup;
      this.configModel = this.configModelBackup;
    },
    saveOrder() {
      const obj = {};

      if (!this.nameScrud) {
        this.$fun.alert("El Scrud no tiene Nombre", "warning");
        return;
      }
      obj.SrdNameScrud = this.nameScrud;

      if (this.configHeaderBackup.length == 0) {
        this.$fun.alert("Arreglo original no contiene items", "warning");
        return;
      }
      obj.SrdOriginalArrangement = JSON.stringify(this.configHeaderBackup);

      if (this.configHeader.length == 0) {
        this.$fun.alert("Arreglo personalizado no contiene items", "warning");
        return;
      }
      obj.SrdCustomArrangement = JSON.stringify(this.configHeader);

      // if(JSON.stringify(this.configHeader) == JSON.stringify(this.configHeaderBackup)){
      //   this.$fun.alert("No se han realizado cambios", "warning");
      //   return;
      // }

      obj.SrdCustomModel = JSON.stringify(this.configModel);
      obj.UsrCreateID = this.$fun.getUserID();
      obj.SrdIsAdmin = this.SrdIsAdmin;
      obj.SecStatus = 1;

      SCrud.save(obj, this.$fun.getUserID()).then((resp) => {
        if (resp.status == 200) {
          this.$fun.alert("Configuración guardada correctamente", "success");
          this.getConfigHeader();
          this.dialogScrud = false;
        }
      });
    },
    configurationEditEvent() {
      if (this.configurationEdit) {
        this.configurationEdit = false;
      } else {
        this.configurationEdit = true;
      }
    },
    getConfigHeader() {
      const ObjFilterScrud = {
        SrdNameScrud: this.nameScrud,
        UsrCreateID: this.$fun.getUserID(),
      };

      SCrud.list(ObjFilterScrud, this.$fun.getUserID()).then((resp) => {
        if (resp.status == 200) {
          if (resp.data.length > 0) {
            this.configHeader = JSON.parse(resp.data[0].SrdCustomArrangement);
            this.configModel = JSON.parse(resp.data[0].SrdCustomModel);

            let configHeaderScrud = this.config.headers;
            let configHeaderOrigen = JSON.parse(
              resp.data[0].SrdOriginalArrangement,
            );
            let configHeaderCustom = JSON.parse(
              resp.data[0].SrdCustomArrangement,
            );

            let configExtra = configHeaderScrud.filter(
              (origen) =>
                !configHeaderOrigen.some(
                  (scrud) => scrud.value === origen.value,
                ),
            );

            if (configExtra.length > 0) {
              for (let extra of configExtra) {
                configHeaderCustom.push(extra);
              }
              this.configHeader = configHeaderCustom;

              const obj = {};
              obj.SrdNameScrud = this.nameScrud;
              obj.SrdOriginalArrangement = JSON.stringify(configHeaderScrud);
              obj.SrdCustomArrangement = JSON.stringify(this.configHeader);
              obj.SrdCustomModel = JSON.stringify(this.configModel);
              obj.UsrCreateID = this.$fun.getUserID();
              obj.SrdIsAdmin = this.SrdIsAdmin;
              obj.SecStatus = 1;

              SCrud.save(obj, this.$fun.getUserID()).then((resp) => {
                if (resp.status == 200) {
                  // console.log("Configuración guardada correctamente", resp);
                }
              });
            }

            this.searchBtn();
          }
        }
      });
    },
    restoreConfiguration() {
      this.$fun
        .alertFull("¿Seguro de restablecer la configuración?", "question")
        .then(async (r) => {
          if (r.value) {
            const obj = {};
            obj.SrdNameScrud = this.nameScrud;
            obj.SrdOriginalArrangement = JSON.stringify(
              this.configHeaderBackup,
            );
            obj.SrdCustomArrangement = JSON.stringify(this.configHeader);
            obj.UsrCreateID = this.$fun.getUserID();
            obj.SrdIsAdmin = this.SrdIsAdmin;
            obj.SecStatus = 0;

            SCrud.save(obj, this.$fun.getUserID()).then((resp) => {
              if (resp.status == 200) {
                // console.log("Configuración restaurada correctamente", resp);
                this.$fun.alert(
                  "Configuración restaurada correctamente",
                  "success",
                );
                this.configHeader = this.config.headers.map((item) => ({
                  ...item,
                  draggable: item.draggable != false,
                }));
                this.dialogScrud = false;
              }
            });
          }
        });
    },
    notBlurInput(key) {
      this.activeTooltip = null;
      this.searchBtn();
      this.configModel[key] =
        (
          this.itemSelectDefinition.find(
            (item) => item.DedValue == this.selectDefinition,
          ) || {}
        ).DedAbbreviation || "";
    },
    editConfigValue(key, event) {
      if (this.remainingHeaders.length == 0) {
        this.$fun.alert(
          "Necesita tener almenos una fila para modificar el tipo de dato",
          "warning",
        );
        return;
      }
      this.tooltipX = event.clientX;
      this.tooltipY = event.clientY;
      this.selectDefinition = null;

      if (!this.configModel[key] && this.selectDefinition == null) {
        this.selectDefinition = 1;
      } else {
        const data = this.configModel[key];
        this.selectDefinition =
          (
            this.itemSelectDefinition.find(
              (item) => item.DedAbbreviation == data,
            ) || {}
          ).DedValue || null;
      }

      if (this.configModel[key] != "ID") {
        this.activeTooltip = key;
      } else {
        this.activeTooltip = null;
        this.$fun.alert("No se puede editar el ID", "warning");
        return;
      }
    },
    formatDataForExcel(headers, data) {
      const normalizeHeader = (text) => {
        return text
          .normalize("NFD") // separa letras de tildes
          .replace(/[\u0300-\u036f]/g, "") // remueve las tildes
          .replace(/\s+/g, "_") // reemplaza espacios por _
          .replace(/[^\w]/g, "") // elimina cualquier carácter raro
          .toUpperCase();
      };

      return data.map((row) => {
        let formattedRow = {};
        headers.forEach((h) => {
          const cleanKey = normalizeHeader(h.text);
          formattedRow[cleanKey] = row[h.value];
        });
        return formattedRow;
      });
    },
    exportExcelFunc() {
      const formattedData = this.formatDataForExcel(
        this.config.headers,
        this.dataExcel,
      );

      GenericService.getConvertExcel(formattedData, this.$fun.getUserID()).then(
        (resp) => {
          this.$fun.downloadFileSH(
            resp.data,
            this.$const.TypeFile.EXCEL,
            `ExcelGeneradoPorScrud`,
          );
        },
      );
    },
  },
  computed: {
    propID() {
      for (var prop in this.configModel)
        if (this.configModel[prop] == "ID") return prop;
      return null;
    },
    remainingHeaders() {
      if (!this.desserts.length) return [];

      const dessertKeys = Object.keys(this.desserts[0]);

      const usedValues = this.configHeader.map((header) => header.value);

      const unusedKeys = dessertKeys.filter((key) => !usedValues.includes(key));

      return unusedKeys.map((key) => ({
        text: key,
        value: key,
      }));
    },
    dessertsFirst() {
      return this.desserts.length ? [this.desserts[0]] : [];
    },
  },
  mounted() {
    this.getAnswer();
  },
  created() {
    this.configHeader = this.config.headers.map((item) => ({
      ...item,
      draggable: item.draggable != false,
    }));

    this.configModel = this.config.model ? { ...this.config.model } : {};
    if (this.nameScrud != "") {
      this.getConfigHeader();
    }

    if (this.noFull) (this.itemsPerPage = [25, 50, 100, 200]), this.restart();

    if (this.filtersActive) {
      this.itemsPerPage = [-1];
    }
    let filterHeaders = [];
    this.config.headers.forEach((element) => {
      if (element.IsLevelAdmin == true) {
        if (this.$fun.getSecurity().IsLevelAdmin) filterHeaders.push(element);
      } else filterHeaders.push(element);

      if (this.configModel[element.value] == "decimal") element.align = "end";
    });
    this.config.headers = filterHeaders;

    this.debouncedGetAnswer = _.debounce(this.getAnswer, 500);

    // DATOS DE DEFINICIÓN
    const objSelectDefinition = {};
    objSelectDefinition.defID = 1544;
    objSelectDefinition.dgrID = 0;
    objSelectDefinition.requestID = this.$fun.getUserID();
    this.$http
      .post(
        _sDefinition.definitiongroupURL(),
        {},
        {
          params: objSelectDefinition,
        },
      )
      .then((r) => {
        if (r.status == 200) {
          this.itemSelectDefinition = r.data;
        }
      });
  },
  destroyed() {},
};
</script>
<style scoped>
.position-absolute {
  position: absolute !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
